import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ExamService } from '../../services/exam.service';
import { SpinnerService } from '../../services/spinner.service';

@Component({
  selector: 'app-home-page',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './home-page.component.html',
  styleUrl: './home-page.component.scss'
})
export class HomePageComponent {

  public formSearch: FormGroup;
  public submitted: boolean = false;
  public errorMessage: string = '';

  constructor(
    private examService: ExamService,
    private formBuilder: FormBuilder,
    private router: Router,
    public spinnerService: SpinnerService,
  ) {

    this.formSearch = this.formBuilder.group({
      idOrFolio: ['', Validators.required],
    });

  }

  get formControls() {
    return this.formSearch.controls;
  }

  async onSubmit() {

    this.submitted = true;
    this.errorMessage = '';

    if(this.formSearch.invalid) {
      return;
    }

    this.spinnerService.loading = true;
    this.spinnerService.message = 'Buscando examen...';

    const folio = this.formSearch.value.idOrFolio;
    const instance = await this.examService.getInstance(folio);

    this.spinnerService.loading = false;
    this.spinnerService.message = '';

    if(!instance) {
      this.errorMessage = 'No se encontró un examen con ese folio o ID.';
      return;
    }

    this.router.navigate(['/exams', folio]);

  }

}
